// extracted by mini-css-extract-plugin
export default {"container":"FooterContainer_container__KeUe3"};